import queryString from 'query-string';
import { toArray } from '../utils.tsx';

export const getColumnStatusMappingUrl = (projectKey: string, boardId: string): string =>
	`/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;

export const getCustomFiltersSettingsUrl = (projectKey: string, boardId: string): string =>
	`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;

export const getCustomFilterFromUrlQuery = ({ search }: Location): string[] | undefined => {
	const queryParameters = queryString.parse(search);
	if (queryParameters?.customFilter) {
		return toArray(queryParameters.customFilter);
	}
	if (queryParameters.quickFilter) {
		return toArray(queryParameters.quickFilter);
	}
	return undefined;
};
